module.exports = __webpack_public_path__ + "static/media/upload.2330b183.svg";